package com.fireavert.auth.reset_password.data_models.responses

import kotlinx.serialization.Serializable

@Serializable
data class PasswordResetResponse(
    val ok: Boolean
)